export function formatNumber(value: number | null | undefined, locale?: string): string {
  return new Intl.NumberFormat(locale).format(value ?? 0);
}

export function formatCurrency(value: number | null | undefined, locale?: string): string {
  return `$${formatNumber(value, locale)}`;
}
